/**
 * @fileoverview gRPC-Web generated client stub for legebill.site.tag.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: legebill/site/tag/v4/tag.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as legebill_site_tag_v4_tag_pb from '../../../../legebill/site/tag/v4/tag_pb';
import * as legebill_type_tag_pb from '../../../../legebill/type/tag_pb';
import * as legebill_type_tag_category_pb from '../../../../legebill/type/tag_category_pb';


export class TagServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/GetTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.GetTagRequest,
    legebill_type_tag_pb.Tag,
    (request: legebill_site_tag_v4_tag_pb.GetTagRequest) => {
      return request.serializeBinary();
    },
    legebill_type_tag_pb.Tag.deserializeBinary
  );

  getTag(
    request: legebill_site_tag_v4_tag_pb.GetTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_tag_pb.Tag>;

  getTag(
    request: legebill_site_tag_v4_tag_pb.GetTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void): grpcWeb.ClientReadableStream<legebill_type_tag_pb.Tag>;

  getTag(
    request: legebill_site_tag_v4_tag_pb.GetTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/GetTag',
        request,
        metadata || {},
        this.methodDescriptorGetTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/GetTag',
    request,
    metadata || {},
    this.methodDescriptorGetTag);
  }

  methodDescriptorBatchGetTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/BatchGetTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.BatchGetTagsRequest,
    legebill_site_tag_v4_tag_pb.BatchGetTagsResponse,
    (request: legebill_site_tag_v4_tag_pb.BatchGetTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.BatchGetTagsResponse.deserializeBinary
  );

  batchGetTags(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.BatchGetTagsResponse>;

  batchGetTags(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchGetTagsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.BatchGetTagsResponse>;

  batchGetTags(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchGetTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/BatchGetTags',
        request,
        metadata || {},
        this.methodDescriptorBatchGetTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/BatchGetTags',
    request,
    metadata || {},
    this.methodDescriptorBatchGetTags);
  }

  methodDescriptorCreateTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/CreateTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.CreateTagRequest,
    legebill_type_tag_pb.Tag,
    (request: legebill_site_tag_v4_tag_pb.CreateTagRequest) => {
      return request.serializeBinary();
    },
    legebill_type_tag_pb.Tag.deserializeBinary
  );

  createTag(
    request: legebill_site_tag_v4_tag_pb.CreateTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_tag_pb.Tag>;

  createTag(
    request: legebill_site_tag_v4_tag_pb.CreateTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void): grpcWeb.ClientReadableStream<legebill_type_tag_pb.Tag>;

  createTag(
    request: legebill_site_tag_v4_tag_pb.CreateTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/CreateTag',
        request,
        metadata || {},
        this.methodDescriptorCreateTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/CreateTag',
    request,
    metadata || {},
    this.methodDescriptorCreateTag);
  }

  methodDescriptorUpdateTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/UpdateTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.UpdateTagRequest,
    legebill_type_tag_pb.Tag,
    (request: legebill_site_tag_v4_tag_pb.UpdateTagRequest) => {
      return request.serializeBinary();
    },
    legebill_type_tag_pb.Tag.deserializeBinary
  );

  updateTag(
    request: legebill_site_tag_v4_tag_pb.UpdateTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_tag_pb.Tag>;

  updateTag(
    request: legebill_site_tag_v4_tag_pb.UpdateTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void): grpcWeb.ClientReadableStream<legebill_type_tag_pb.Tag>;

  updateTag(
    request: legebill_site_tag_v4_tag_pb.UpdateTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.Tag) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/UpdateTag',
        request,
        metadata || {},
        this.methodDescriptorUpdateTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/UpdateTag',
    request,
    metadata || {},
    this.methodDescriptorUpdateTag);
  }

  methodDescriptorListTagsByCategory = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/ListTagsByCategory',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.ListTagsByCategoryRequest,
    legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse,
    (request: legebill_site_tag_v4_tag_pb.ListTagsByCategoryRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse.deserializeBinary
  );

  listTagsByCategory(
    request: legebill_site_tag_v4_tag_pb.ListTagsByCategoryRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse>;

  listTagsByCategory(
    request: legebill_site_tag_v4_tag_pb.ListTagsByCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse>;

  listTagsByCategory(
    request: legebill_site_tag_v4_tag_pb.ListTagsByCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListTagsByCategoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/ListTagsByCategory',
        request,
        metadata || {},
        this.methodDescriptorListTagsByCategory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/ListTagsByCategory',
    request,
    metadata || {},
    this.methodDescriptorListTagsByCategory);
  }

  methodDescriptorBatchListTagsByCategories = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/BatchListTagsByCategories',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesRequest,
    legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse,
    (request: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse.deserializeBinary
  );

  batchListTagsByCategories(
    request: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse>;

  batchListTagsByCategories(
    request: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse>;

  batchListTagsByCategories(
    request: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchListTagsByCategoriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/BatchListTagsByCategories',
        request,
        metadata || {},
        this.methodDescriptorBatchListTagsByCategories,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/BatchListTagsByCategories',
    request,
    metadata || {},
    this.methodDescriptorBatchListTagsByCategories);
  }

  methodDescriptorListTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/ListTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.ListTagsRequest,
    legebill_site_tag_v4_tag_pb.ListTagsResponse,
    (request: legebill_site_tag_v4_tag_pb.ListTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.ListTagsResponse.deserializeBinary
  );

  listTags(
    request: legebill_site_tag_v4_tag_pb.ListTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.ListTagsResponse>;

  listTags(
    request: legebill_site_tag_v4_tag_pb.ListTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListTagsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.ListTagsResponse>;

  listTags(
    request: legebill_site_tag_v4_tag_pb.ListTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/ListTags',
        request,
        metadata || {},
        this.methodDescriptorListTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/ListTags',
    request,
    metadata || {},
    this.methodDescriptorListTags);
  }

  methodDescriptorDeleteAllConnectorTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/DeleteAllConnectorTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.DeleteAllConnectorTagsRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_tag_v4_tag_pb.DeleteAllConnectorTagsRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteAllConnectorTags(
    request: legebill_site_tag_v4_tag_pb.DeleteAllConnectorTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteAllConnectorTags(
    request: legebill_site_tag_v4_tag_pb.DeleteAllConnectorTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteAllConnectorTags(
    request: legebill_site_tag_v4_tag_pb.DeleteAllConnectorTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/DeleteAllConnectorTags',
        request,
        metadata || {},
        this.methodDescriptorDeleteAllConnectorTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/DeleteAllConnectorTags',
    request,
    metadata || {},
    this.methodDescriptorDeleteAllConnectorTags);
  }

  methodDescriptorSearchTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/SearchTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    legebill_site_tag_v4_tag_pb.SearchTagsResponse,
    (request: legebill_site_tag_v4_tag_pb.SearchTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.SearchTagsResponse.deserializeBinary
  );

  searchTags(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.SearchTagsResponse>;

  searchTags(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.SearchTagsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.SearchTagsResponse>;

  searchTags(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.SearchTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/SearchTags',
        request,
        metadata || {},
        this.methodDescriptorSearchTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/SearchTags',
    request,
    metadata || {},
    this.methodDescriptorSearchTags);
  }

  methodDescriptorSearchTagsShallow = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/SearchTagsShallow',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow,
    (request: legebill_site_tag_v4_tag_pb.SearchTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow.deserializeBinary
  );

  searchTagsShallow(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow>;

  searchTagsShallow(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow>;

  searchTagsShallow(
    request: legebill_site_tag_v4_tag_pb.SearchTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.SearchTagsResponseShallow) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/SearchTagsShallow',
        request,
        metadata || {},
        this.methodDescriptorSearchTagsShallow,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/SearchTagsShallow',
    request,
    metadata || {},
    this.methodDescriptorSearchTagsShallow);
  }

  methodDescriptorCreateTagKeyword = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/CreateTagKeyword',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.CreateTagKeywordRequest,
    legebill_type_tag_pb.TagKeyword,
    (request: legebill_site_tag_v4_tag_pb.CreateTagKeywordRequest) => {
      return request.serializeBinary();
    },
    legebill_type_tag_pb.TagKeyword.deserializeBinary
  );

  createTagKeyword(
    request: legebill_site_tag_v4_tag_pb.CreateTagKeywordRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_tag_pb.TagKeyword>;

  createTagKeyword(
    request: legebill_site_tag_v4_tag_pb.CreateTagKeywordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.TagKeyword) => void): grpcWeb.ClientReadableStream<legebill_type_tag_pb.TagKeyword>;

  createTagKeyword(
    request: legebill_site_tag_v4_tag_pb.CreateTagKeywordRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_tag_pb.TagKeyword) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/CreateTagKeyword',
        request,
        metadata || {},
        this.methodDescriptorCreateTagKeyword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/CreateTagKeyword',
    request,
    metadata || {},
    this.methodDescriptorCreateTagKeyword);
  }

  methodDescriptorDeleteTagKeyword = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/DeleteTagKeyword',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.DeleteTagKeywordRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_tag_v4_tag_pb.DeleteTagKeywordRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTagKeyword(
    request: legebill_site_tag_v4_tag_pb.DeleteTagKeywordRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTagKeyword(
    request: legebill_site_tag_v4_tag_pb.DeleteTagKeywordRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTagKeyword(
    request: legebill_site_tag_v4_tag_pb.DeleteTagKeywordRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/DeleteTagKeyword',
        request,
        metadata || {},
        this.methodDescriptorDeleteTagKeyword,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/DeleteTagKeyword',
    request,
    metadata || {},
    this.methodDescriptorDeleteTagKeyword);
  }

  methodDescriptorListFavouriteTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/ListFavouriteTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.ListFavouriteTagsRequest,
    legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse,
    (request: legebill_site_tag_v4_tag_pb.ListFavouriteTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse.deserializeBinary
  );

  listFavouriteTags(
    request: legebill_site_tag_v4_tag_pb.ListFavouriteTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse>;

  listFavouriteTags(
    request: legebill_site_tag_v4_tag_pb.ListFavouriteTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse>;

  listFavouriteTags(
    request: legebill_site_tag_v4_tag_pb.ListFavouriteTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListFavouriteTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/ListFavouriteTags',
        request,
        metadata || {},
        this.methodDescriptorListFavouriteTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/ListFavouriteTags',
    request,
    metadata || {},
    this.methodDescriptorListFavouriteTags);
  }

  methodDescriptorCreateFavouriteTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/CreateFavouriteTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.CreateFavouriteTagRequest,
    legebill_site_tag_v4_tag_pb.FavouriteTag,
    (request: legebill_site_tag_v4_tag_pb.CreateFavouriteTagRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.FavouriteTag.deserializeBinary
  );

  createFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.CreateFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.FavouriteTag>;

  createFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.CreateFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.FavouriteTag) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.FavouriteTag>;

  createFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.CreateFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.FavouriteTag) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/CreateFavouriteTag',
        request,
        metadata || {},
        this.methodDescriptorCreateFavouriteTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/CreateFavouriteTag',
    request,
    metadata || {},
    this.methodDescriptorCreateFavouriteTag);
  }

  methodDescriptorReorderFavouriteTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/ReorderFavouriteTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.ReorderFavouriteTagRequest,
    legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse,
    (request: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse.deserializeBinary
  );

  reorderFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse>;

  reorderFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse>;

  reorderFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ReorderFavouriteTagResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/ReorderFavouriteTag',
        request,
        metadata || {},
        this.methodDescriptorReorderFavouriteTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/ReorderFavouriteTag',
    request,
    metadata || {},
    this.methodDescriptorReorderFavouriteTag);
  }

  methodDescriptorDeleteFavouriteTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/DeleteFavouriteTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.DeleteFavouriteTagRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_tag_v4_tag_pb.DeleteFavouriteTagRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteFavouriteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteFavouriteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/DeleteFavouriteTag',
        request,
        metadata || {},
        this.methodDescriptorDeleteFavouriteTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/DeleteFavouriteTag',
    request,
    metadata || {},
    this.methodDescriptorDeleteFavouriteTag);
  }

  methodDescriptorListRecentTags = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/ListRecentTags',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.ListRecentTagsRequest,
    legebill_site_tag_v4_tag_pb.ListRecentTagsResponse,
    (request: legebill_site_tag_v4_tag_pb.ListRecentTagsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.ListRecentTagsResponse.deserializeBinary
  );

  listRecentTags(
    request: legebill_site_tag_v4_tag_pb.ListRecentTagsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.ListRecentTagsResponse>;

  listRecentTags(
    request: legebill_site_tag_v4_tag_pb.ListRecentTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListRecentTagsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.ListRecentTagsResponse>;

  listRecentTags(
    request: legebill_site_tag_v4_tag_pb.ListRecentTagsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.ListRecentTagsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/ListRecentTags',
        request,
        metadata || {},
        this.methodDescriptorListRecentTags,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/ListRecentTags',
    request,
    metadata || {},
    this.methodDescriptorListRecentTags);
  }

  methodDescriptorDeleteTag = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/DeleteTag',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.DeleteTagRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_tag_v4_tag_pb.DeleteTagRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteTagRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteTag(
    request: legebill_site_tag_v4_tag_pb.DeleteTagRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/DeleteTag',
        request,
        metadata || {},
        this.methodDescriptorDeleteTag,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/DeleteTag',
    request,
    metadata || {},
    this.methodDescriptorDeleteTag);
  }

  methodDescriptorGetTagCategory = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/GetTagCategory',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.GetTagCategoryRequest,
    legebill_type_tag_category_pb.TagCategory,
    (request: legebill_site_tag_v4_tag_pb.GetTagCategoryRequest) => {
      return request.serializeBinary();
    },
    legebill_type_tag_category_pb.TagCategory.deserializeBinary
  );

  getTagCategory(
    request: legebill_site_tag_v4_tag_pb.GetTagCategoryRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_tag_category_pb.TagCategory>;

  getTagCategory(
    request: legebill_site_tag_v4_tag_pb.GetTagCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_tag_category_pb.TagCategory) => void): grpcWeb.ClientReadableStream<legebill_type_tag_category_pb.TagCategory>;

  getTagCategory(
    request: legebill_site_tag_v4_tag_pb.GetTagCategoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_tag_category_pb.TagCategory) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/GetTagCategory',
        request,
        metadata || {},
        this.methodDescriptorGetTagCategory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/GetTagCategory',
    request,
    metadata || {},
    this.methodDescriptorGetTagCategory);
  }

  methodDescriptorBatchGetTagCategories = new grpcWeb.MethodDescriptor(
    '/legebill.site.tag.v4.TagService/BatchGetTagCategories',
    grpcWeb.MethodType.UNARY,
    legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesRequest,
    legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse,
    (request: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse.deserializeBinary
  );

  batchGetTagCategories(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse>;

  batchGetTagCategories(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse>;

  batchGetTagCategories(
    request: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_tag_v4_tag_pb.BatchGetTagCategoriesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.tag.v4.TagService/BatchGetTagCategories',
        request,
        metadata || {},
        this.methodDescriptorBatchGetTagCategories,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.tag.v4.TagService/BatchGetTagCategories',
    request,
    metadata || {},
    this.methodDescriptorBatchGetTagCategories);
  }

}

